import { render, staticRenderFns } from "./ShippersExport.vue?vue&type=template&id=80d06f50&scoped=true"
import script from "./ShippersExport.vue?vue&type=script&lang=js"
export * from "./ShippersExport.vue?vue&type=script&lang=js"
import style0 from "./ShippersExport.vue?vue&type=style&index=0&id=80d06f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d06f50",
  null
  
)

export default component.exports